export default '/static/frontend/ReachDigital/12gobiking/dist/assets/postnord-2f4d93a7.svg'